module.exports = __webpack_public_path__ + "img/sec_in3.6922b0a4.jpg";